<template>
  <nav class="navbar navbar-expand-md bg-white navbar-light shadow-sm pt-2 ps-1 pe-3">
    <div class="container-fluid">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item">
          <button class="btn" @click="toggleSidebar()"><font-awesome-icon icon="bars" /></button>
        </li>
      </ul>

      <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
        <!-- <li class="nav-item dropdown my-auto">
          <img src="@/assets/img/profilbild.png" alt="Profil Bild Rainer Zufall" class="avatar me-2" />

          <a
            class="nav-link dropdown-toggle d-inline pe-0"
            href="#"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            >{{user?.benutzer}}</a>

          <ul class="dropdown-menu m-0">
            <li>
              <button class="dropdown-item" @click="logout">
                <font-awesome-icon
                  icon="arrow-right-from-bracket"
                  class="pe-3"
                />
                Abmelden
              </button>
            </li>
          </ul>
        </li> -->
        <li class="nav-item dropdown my-auto ms-5">
          <img src="@/assets/img/profilbild.png" alt="Profil Bild" class="avatar me-1" />

          <a class="nav-link dropdown-toggle d-inline pe-0" href="#" data-bs-toggle="dropdown" aria-expanded="false">{{ user?.benutzer }}</a>
          <ul class="dropdown-menu dropdown-menu-end p-0 m-0" style="width: 370px">
            <div class="row mx-0 rounded-bottom-0 dd-header shadow-sm">
              <div class="col-8 px-1 my-auto"><img src="@/assets/icons/1a_connect.png" class="me-1" width="48" /> 1.A Connect GmbH</div>

              <div class="col-4 px-1 my-auto text-end">
                <span class="logout-btn" @click="logout()"> Abmelden </span>
              </div>
            </div>

            <div class="row mt-2 mx-0">
              <div class="col-5 p-2 d-flex align-items-center justify-content-start">
                <img src="@/assets/img/profilbild.png" alt="Profil Bild" class="avatar-large" />
              </div>

              <div class="col p-2 my-auto">
                <p class="fw-bold mb-1">{{ user?.benutzer }}</p>
                <p class="text-muted mb-0">{{ user?.username }}</p>
                <!-- <p class="text-muted mb-2">{{ authStore.email }}</p> -->

                <!-- <p class="mb-1"><a href="http://192.168.10.122:8000/realms/kunde1/account">Profil bearbeiten</a></p> -->
                <p class="mb-1"><router-link :to="{ name: 'Einstellungen' }">Einstellungen</router-link></p>
              </div>
            </div>
            <li class="dropdown-item"></li>
          </ul>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  import { useStore } from '@/store';
  import { useRouter } from 'vue-router';

  import { ActionTypes as AuthActionTypes } from '@/store/modules/Auth/actions';
  import { ActionTypes as CommonActionTypes } from '@/store/modules/Common/actions';

  export default defineComponent({
    name: 'Navbar',

    setup() {
      const store = useStore();
      const router = useRouter();

      const user = store.getters.authUser;

      return {
        store,
        router,
        user,
      };
    },

    data() {
      return {
        screenWidth: 0,
      };
    },

    methods: {
      logout() {
        this.store.dispatch(AuthActionTypes.Logout, undefined).then(() => {
          this.router.replace({ name: 'Logout' });
        });
      },

      toggleSidebar() {
        this.store.dispatch(CommonActionTypes.ToggleSidebar, undefined);
      },
    },

    created() {
      this.screenWidth = window.innerWidth;
    },
  });
</script>

<style lang="scss" scoped>
  img.avatar {
    object-fit: cover;
    border-radius: 50%;
    border: 3px solid #2a579b;
    height: 40px;
    width: 40px;
  }

  img.avatar-large {
    object-fit: cover;
    border-radius: 50%;
    border: 3px solid #2a579b;
    height: 96px;
    width: 96px;
  }

  .dd-header {
    background: rgb(242, 243, 248);
    padding: 10px;
    border-radius: 5px;
  }

  .logout-btn:hover {
    cursor: pointer;
    color: #2a579b;
  }

  #mainNav {
    z-index: 2;
  }
</style>
